export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8525.d88bb20c.jpg";